import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { AcademyVideoCategorizationForm, type CategorizationFormValues } from './AcademyVideoCategorizationForm';
import type { AcademyVideoItem } from '../types';

interface AcademyVideoEditCategoriesModalProps {
    video: AcademyVideoItem | null;
    isOpen: boolean;
    onClose: () => void;
    onSave: (videoId: string, values: CategorizationFormValues) => Promise<void>;
    isSaving?: boolean;
}

function parseJsonArray(val: unknown): string[] {
    if (!val) return [];
    if (Array.isArray(val)) return val.filter((x): x is string => typeof x === 'string');
    if (typeof val === 'string') {
        try {
            const arr = JSON.parse(val);
            return Array.isArray(arr) ? arr.filter((x): x is string => typeof x === 'string') : [];
        } catch {
            return [];
        }
    }
    return [];
}

export function AcademyVideoEditCategoriesModal({
    video,
    isOpen,
    onClose,
    onSave,
    isSaving = false,
}: AcademyVideoEditCategoriesModalProps) {
    if (!video) return null;

    const initialValues: Partial<CategorizationFormValues> = {
        modalities: parseJsonArray(video.modalities),
        species: parseJsonArray(video.species),
        location_types: parseJsonArray(video.location_types),
        water_type: video.water_type ?? '',
        content_type: video.content_type ?? '',
        language_code: video.language_code ?? '',
        level: video.level ?? '',
    };

    const handleSave = async (values: CategorizationFormValues) => {
        await onSave(video.id, values);
        onClose();
    };

    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle>Editar categorías</DialogTitle>
                </DialogHeader>
                <p className="text-sm text-muted-foreground line-clamp-2 mb-4">{video.title}</p>
                <AcademyVideoCategorizationForm
                    videoId={video.id}
                    initialValues={initialValues}
                    onSave={handleSave}
                    onCancel={onClose}
                    isSaving={isSaving}
                />
            </DialogContent>
        </Dialog>
    );
}
